import { assignInlineVars } from '@vanilla-extract/dynamic';
import { getMiniMoveY } from './get-mini-move-y';
import { getNanoMoveY } from './get-nano-move-y';
import {
  getWidgetColor,
  getWidgetGradient,
  isColorLight,
} from '../core/userway';
import {
  textColor,
  widgetGradientColor,
  miniMoveY,
  nanoMoveY,
} from '../core/variable.css';

export const getWidgetColorVar = (
  gradientVar: typeof widgetGradientColor,
  mainColorVar?: typeof widgetGradientColor,
) => {
  const colors = {
    [gradientVar]: getWidgetGradient() || getWidgetColor(),
  };
  if (mainColorVar) {
    colors[mainColorVar] = getWidgetColor();
  }
  return assignInlineVars(colors);
};

export const getTextColorVar = (variable: typeof textColor) =>
  assignInlineVars({
    [variable]: isColorLight(getWidgetColor()) ? '#000' : '#fff',
  });

export const getMiniMoveYVar = (variable: typeof miniMoveY) =>
  assignInlineVars({
    [variable]: `${getMiniMoveY()}px`,
  });

export const getNanoMoveYVar = (variable: typeof nanoMoveY) =>
  assignInlineVars({
    [variable]: `${getNanoMoveY()}px`,
  });
